var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gzhBtn"},[_c('img',{staticClass:"gzhIcon",attrs:{"src":"https://apkpic.86122m.com/gzhIcon.png"}}),_c('span',[_vm._v(_vm._s(_vm.item.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }